import { UserOrganizationRequestResponse } from "../../../api-models/response/user/UserResponse";
import { translationService } from "../../translation/TranslationService";
import { dateService } from "../../date-service/DateService";
import { RowItemData } from "../../../components/datatable/interfaces";
import {
  OrganizationRequestStatuses,
  OrganizationRequestTypes,
} from "../../../generated/OrganizationRequests";

export class UserOrganizationRequest implements RowItemData {
  id: number;
  private name: string;
  private status: OrganizationRequestStatuses;
  private type: OrganizationRequestTypes;
  private requestDate: Date;
  private generalManagerName: string;
  private phone: string;

  constructor(userOrganizationRequestResponse: UserOrganizationRequestResponse) {
    this.id = userOrganizationRequestResponse.id;
    this.name = userOrganizationRequestResponse.organizationName;
    this.type = userOrganizationRequestResponse.type;
    this.status = userOrganizationRequestResponse.status;
    this.generalManagerName = userOrganizationRequestResponse.generalManagerName;
    this.phone = userOrganizationRequestResponse.phone;
    this.requestDate = userOrganizationRequestResponse.requestDate;
  }

  get displayValues() {
    return {
      organizationName: { toDisplay: this.name },
      status: {
        toDisplay: translationService.translate(
          `organization.request.status.${OrganizationRequestStatuses[this.status]}`
        ),
      },
      type: {
        toDisplay: translationService.translate(
          `organization.request.type.${OrganizationRequestTypes[this.type]}`
        ),
      },
      requestDate: {
        toDisplay: dateService.formatDate(this.requestDate),
      },
      generalManagerName: { toDisplay: this.generalManagerName },
      phone: { toDisplay: this.phone },
    };
  }
}
